<script>
    export let row = {};
</script>

{#if row.days_pending >= 0 && row.approvers}
  <div style="text-align: center;">
    {row.days_pending}
  </div>
{/if}
